module.exports = __webpack_public_path__ + "img/icon-instagram - w.c292e568.svg";